// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"58":"b30d7f61","244":"bf40d398","395":"89fd112d","610":"3b4a3709","821":"20b86891","883":"1450d9ef","923":"e38bba86"}[chunkId] + ".css";
};